// extracted by mini-css-extract-plugin
module.exports = {"panel":"compound-interest-calculator_panel__JUUuT","toolbar":"compound-interest-calculator_toolbar__s1zGH","form":"compound-interest-calculator_form__GafJe"};